import React from "react";
import { string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import TagsIcon from "../icons/tagsIcon";

import "./tags.m.css";

const Tags = ({ data = {}, domainLink }) => {
  const tagLink = domainLink + "/topic/" + data.slug;
  return (
    <React.Fragment>
      <Link href={tagLink}>
        <p styleName="tags-container" className="tags-container">
          <TagsIcon />
          <span styleName="tag-name">{data.name}</span>
        </p>
      </Link>
    </React.Fragment>
  );
};

Tags.propTypes = {
  data: object,
  domainLink: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainLink: get(state, ["qt", "currentHostUrl"], {}),
});

export default connect(mapStateToProps, null)(Tags);
